import { useState } from "react";
import Cookies, { CookieSetOptions } from "universal-cookie";

type Cookie = string | null;
type Set = (value: any, options?: CookieSetOptions) => void;
type Remove = (options?: CookieSetOptions) => void;

const useCookie = (key: string): [Cookie, Set, Remove] => {
  const cookies = new Cookies();
  const [cookie, setItemValue] = useState<Cookie>(() => {
    return cookies.get(key) || null;
  });

  const set: Set = (value, options) => {
    setItemValue(value);
    cookies.set(key, value, options);
  };

  const remove = (options?: CookieSetOptions) => {
    setItemValue(null);
    cookies.remove(key, options);
  };

  return [cookie, set, remove];
};

export default useCookie;
